﻿﻿export interface IHomeBloodDrawRequest {
    organType?: number,

    // Ship To
    firstName: string,
    lastName: string,
    address1: string,
    address2: string,
    contactPhone: string,
    email: string,
    dob: string,

    // Return To
    returnName: string,
    returnAddress1: string,
    returnAddress2: string,
    returnCity: string,
    returnState: string,
    returnPostalCode: string,
    returnContactPhone: string,
    billingRef: string,
    isPhlebot: boolean,

    // Tubes
    lav10ml: number,
    pink10ml: number,
    red10ml: number,
    green10ml: number,
    yellow85ml: number,
    blue45ml?: number
}